export const financeOptions = {
  availableOptions: {
    HP: "HP",
    PCP: "PCP"
  },
  numberOfRepayments: 36,
  defaultDepositOfCarValuePrecentage: 0.2
};

export const apiResponseMessages = {
  OK: "OK",
  ERROR: "ERROR",
  PENDING: "PENDING"
};

export const hpOptions = {
  hpTerms: [24, 36, 48, 60],
  defaultHpTerm: 60
};
